import { useState } from "react";
import { ContactUsRequest } from "./types";
import { useContactUs } from "./queries";
import {
  allSchemaFieldsValidGeneric,
  newValidatedField,
  setValidatedFieldTrue,
  validateSchemaGeneric,
  ValidationSchemaGeneric,
} from "dataTypes/controls/interfaces/validationSchema";
import { ValidationType } from "dataTypes/controls/enums/validationType";

export const useContactUsForm = (initialRequest?: ContactUsRequest) => {
  // form state
  const [request, setRequest] = useState(initialRequest || new ContactUsRequest());

  // form validation
  const initialValidation = {
    name: newValidatedField(true, [ValidationType.Value]),
    email: newValidatedField(true, [ValidationType.Email]),
    topic: newValidatedField(true, [ValidationType.Value]),
    message: newValidatedField(true, [ValidationType.Value]),
  };

  const [validation, setValidation] = useState<ValidationSchemaGeneric<ContactUsRequest>>(initialValidation);

  // mutation query
  const contactUsMutation = useContactUs();

  const handleInputChange = (name: string, value: string) => {
    setRequest((state) => ({
      ...state,
      [name]: value,
    }));

    setValidation((validation) => setValidatedFieldTrue<ContactUsRequest>(validation, name as keyof ContactUsRequest));
  };

  const resetForm = (request?: ContactUsRequest) => {
    setRequest(request || new ContactUsRequest());
    setValidation(initialValidation);
  };

  const validateForm = () => {
    const newValidation = validateSchemaGeneric(request, validation);
    setValidation(newValidation);
    return allSchemaFieldsValidGeneric(newValidation);
  };

  return {
    request,
    validation,
    contactUsMutation,
    resetForm,
    validateForm,
    handleInputChange,
  };
};
